module.exports = __webpack_public_path__ + "static/orthodontics06-3b9dfcc314372ef5e4c574a2eb516f02.jpg";